module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./EquityView.js"));
	}, "EquityView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EquityView!./src/pages/Promote/Equity/EquityView.js
// module id = 1640
// module chunks = 418